var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopupWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8E5",
    d: "M55 0C24.672 0 0 24.672 0 55s24.672 55 55 55 55-24.672 55-55S85.328 0 55 0z",
    transform: "translate(-40 -7793) translate(0 6947) translate(40 846)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.917 52.01c0 3.282-2.668 5.943-5.959 5.943-3.29 0-5.958-2.66-5.958-5.944 0-3.282 2.668-5.944 5.958-5.944s5.959 2.662 5.959 5.944zM5.958 0c3.29 0 5.959 2.661 5.959 5.944v28.234c0 3.282-2.668 5.943-5.959 5.943-3.29 0-5.958-2.66-5.958-5.943V5.944C0 2.661 2.668 0 5.958 0z",
    transform: "translate(-40 -7793) translate(0 6947) translate(40 846) translate(50 26)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupWarn);
export default __webpack_public_path__ + "static/media/popup-warn.f213125bb94ab4692a25fbdf93fd46e8.svg";
export { ForwardRef as ReactComponent };